import axios from 'axios';
import apiZelo from '../backAxiosComissoesToken';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const url = retornoHashValor(process.env.REACT_APP_7);
const token = process.env.REACT_APP_URL_COMISSOES_TOKEN;

const comissao = axios.create({
    baseURL: url ,
    headers: {
        'Authorization': token
    }
});

export default comissao;

export const CalculoComissao = async (tipo, values) => {
    try {
        const response = await apiZelo.post(`/comissao/${tipo}`, values);

        return response.data;
    } catch (error) {
        return error;
    }
};
